import { Injectable } from '@angular/core';
import { env } from 'process';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentStatusService {

  private socket!: WebSocket;

  private statusSubject = new BehaviorSubject<any>(null);
  status$: Observable<any> = this.statusSubject.asObservable();

  constructor() {
    this.connect();
  }

  private connect() {
    let wsUrl = environment.apiUrl.replace('https', 'wss') + "status/";
    wsUrl = wsUrl.replace('v1/', '')
    this.socket = new WebSocket(wsUrl);

    this.socket.onopen = () => {
      console.log("WS conectado");
    };

    this.socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);

        this.statusSubject.next(data);
      } catch (e) {
        console.error("Error procesando mensaje:", e);
      }
    };

    this.socket.onerror = (err) => {
      console.error("WebSocket error:", err);
    };

    this.socket.onclose = () => {
      console.warn("WS cerrado. Reintentando...");
      setTimeout(() => this.connect(), 3000);
    };
  }
}
